import moment from "moment";

const getTimeSince = (dateTime) => {
  const startTime = moment(dateTime);
  const endTime = moment().utc();
  const totalMinutes = endTime.diff(startTime, "minutes");
  const days = Math.floor(totalMinutes / (24 * 60));
  const remainingMinutesAfterDays = totalMinutes % (24 * 60);
  const hours = Math.floor(remainingMinutesAfterDays / 60);
  const minutes = remainingMinutesAfterDays % 60;

  if (hours < 1 && days < 1) {
    return `${minutes} minutes ago`;
  } else if (days < 1) {
    return `${hours} hours ago`;
  } else {
    return `${days} days ago`;
  }
};

export { getTimeSince };
